module.exports = __webpack_public_path__ + "static/img/xqypic001.906489e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xqypic001.jpg
// module id = 6pTP
// module chunks = 1